export function transformRequest(priceTileApiUrl, priceTileApiKey, tileApiUrl, tileApiKey) {
    return function (url) {
        if (url.startsWith(priceTileApiUrl)) {
            return {
                url,
                headers: { 'X-Api-Key': priceTileApiKey },
            };
        }
        if (url.startsWith(tileApiUrl)) {
            return {
                url,
                headers: { 'X-Api-Key': tileApiKey },
            };
        }
        return {
            url,
        };
    };
}
